const topicRefinement = [
  {
    id: 1,
    name: 'Investors/Customer Request Analysis',
    desc: 'Upload lists of questions received from customers and investors',
    active: true,
    configure: true,
    type: 'topic_1_requests',
  },
  {
    id: 2,
    name: 'Non Sustainability Regulatory Disclosures',
    desc: 'Upload a list of regulatory ESG related disclosures outside of corporate reporting.',
    active: true,
    configure: true,
    type: 'topic_1_disclosures',
  },
  {
    id: 3,
    name: 'Peer/Competitor Insights',
    desc: 'Analyse what topics are your selected competitors reporting on and how are they performing on them.',
    active: true,
    configure: true,
    type: 'topic_1_peer_competitor_insights',
  },
  {
    id: 4,
    name: 'Stakeholder Insights',
    desc: 'What are our most important customers, suppliers and other stakeholder '
    + 'topics based on publicly available data.',
    active: true,
    configure: false,
    type: 'topic_1_stakeholder_insights',
  },
  {
    id: 5,
    name: 'Geographically Specific',
    desc: 'Select important topics based on value chain site entities physical addresses.',
    active: true,
    configure: true,
    type: 'topic_1_geographic_risks',
  },
  {
    id: 6,
    name: 'Industry Specific',
    desc: 'Select important topics based on value chain nace code selection.',
    active: true,
    configure: true,
    type: 'topic_1_nace_section_risks',
  },
];

export default topicRefinement;

export const questionsDisclosure = [
  {
    id: 1,
    disclosure: 'What is the impact of our operations on local communities?',
    category: {
      label: 'Social',
      value: 'social',
    },
    country: {
      label: 'Ukraine',
      value: 'UA',
    },
    requiredBy: 'Example Corp',
    source: 'Annual Report 2023',
  },
  {
    id: 2,
    disclosure: 'How do we ensure customer data privacy?',
    category: {
      label: 'Governance',
      value: 'governance',
    },
    country: {
      label: 'Ukraine',
      value: 'UA',
    },
    requiredBy: 'Tech Solutions Inc.',
    source: 'Data Privacy Policy',
  },
];
